export const white = '#ffffff';
export const veryLightGrey = '#fafafa';
export const lightGrey = '#f5f5f5';
export const darkGrey = '#545454';
export const midGrey = '#8c8c8c';
export const grey = '#cacaca';
export const black = '#262626';

export const hsBlue = '#32239b';
export const hsBlue50 = '#9891cd';
export const hsBlue20 = '#d6d3eb';
export const hsBlue5 = '#f5f4fa';

export const blue = '#25bbff';
export const blue50 = '#8edcff';
export const blue20 = '#d2f1ff';
export const blue10 = '#e9f8ff';
export const blue5 = '#f4fbff';

export const darkBlue = '#2593ff';
export const darkBlue20 = '#D3E9FF';

export const purple = '#644eb2';
export const purple50 = '#b1a5da';
export const purple20 = '#e0dcf1';
export const purple10 = '#efedf7';
export const purple5 = '#f7f6fb';
export const purple2 = '#e0dcf0';

export const pink = '#ee3d85';
export const pink50 = '#f89dc2';
export const pink20 = '#fdd8e7';
export const pink10 = '#fdebf2';
export const pink5 = '#FFF2F7';

export const green = '#22bf76';
export const green50 = '#8ddfb9';
export const green20 = '#d2f2e4';
export const green10 = '#e8f8f1';
export const green5 = '#f4fcf8';

export const peach = '#F78B55';
export const peach50 = '#f4ac87';
export const peach10 = '#fff1ea';

export const darkGreen = '#229078';
export const darkGreen20 = '#D3E9E4';

export const transparent = '#00000000';

export const brown = '#835D1A';

export const Neutral500 = '#202020';
export const Neutral400 = '#545454';
export const Neutral300 = '#C0C0C0';
export const Neutral200 = '#E8E8E8';
export const Neutral100 = '#F5F5F5';
export const Neutral000 = '#FFFFFF';

export const MemberGreen700 = '#0B2621';
export const MemberGreen600 = '#12493D';
export const MemberGreen500 = '#1F856F';
export const MemberGreen400 = '#33CDAC';
export const MemberGreen300 = '#5AB5A1';
export const MemberGreen200 = '#A0D1C8';
export const MemberGreen100 = '#E8F8F1';

export const ExpertBlue700 = '#0B2733';
export const ExpertBlue600 = '#104467';
export const ExpertBlue500 = '#0066AC';
export const ExpertBlue400 = '#A0C5FF';
export const ExpertBlue300 = '#A0BDD1';
export const ExpertBlue200 = '#D2E5ED';
export const ExpertBlue100 = '#E9F8FF';

export const Orange100 = '#FDF1E8';
export const Orange300 = '#F6C197';
export const Orange700 = '#A17049';

export const Yellow100 = '#FEFAD3';
export const Yellow300 = '#FCEF7F';
export const Yellow700 = '#CEBB0D';

export const Danger100 = '#FFF1F1';
export const Danger200 = '#F8A0A0';
export const Danger300 = '#F25757';
export const Danger400 = '#993636';
